import { propEq } from 'ramda'

import { useAVERAGE_EVENTS_AMOUNT_BY_PERIOD_CONFIG } from './events/averageAmountByPeriod/_config/config'
import { useAVERAGE_FORM_REPLIES_AMOUNT_BY_PERIOD_CONFIG } from './formReplies/averageAmountByPeriod/_config/config'
import {
  useCHECKLISTS_RANKING_CONFIG,
  usePLACES_RANKING_CONFIG,
  useUSERS_RANKING_CONFIG
} from './general/ranking/_config/config'
import { useCOMPLIANCES_COUNTER_CONFIG } from './compliances/counter/_config/config'
import { useFORMS_COUNTER_CONFIG } from './forms/counter/_config/config'
import { useFORM_REPLIES_COUNTER_CONFIG } from './formReplies/counter/_config/config'
import { useGROUPED_EVENTS_BY_REASON_CONFIG } from './events/groupedByReason/_config/config'
import { useGROUPED_NON_COMPLIANCES_CONFIG } from './compliances/grouped/_config/config'
import { useNON_COMPLIANCES_COUNTER_CONFIG } from './nonCompliances/counter/_config/config'
import { usePERIODIC_FORM_REPLIES_CONFIG } from './formReplies/periodic/_config/config'
import { usePERIODIC_NON_COMPLIANCES_CONFIG } from './compliances/periodic/_config/config'
import { usePERIODIC_SERVICE_ORDERS_BY_STATUS_CONFIG } from './serviceOrders/periodicByStatus/_config/config'
import { usePLACES_COUNTER_CONFIG } from './places/counter/_config/config'
import { useSERVICE_ORDERS_COUNTER_CONFIG } from './serviceOrders/counter/_config/config'
import { useUSERS_COUNTER_CONFIG } from './users/counter/_config/config'
import { useEMBED_CONFIG } from './embed/_config/config'

export const useWIDGET_CONFIGS = () => {
  const COMPLIANCES_COUNTER_CONFIG = useCOMPLIANCES_COUNTER_CONFIG()
  const NON_COMPLIANCES_COUNTER_CONFIG = useNON_COMPLIANCES_COUNTER_CONFIG()
  const PERIODIC_NON_COMPLIANCES_CONFIG = usePERIODIC_NON_COMPLIANCES_CONFIG()
  const GROUPED_NON_COMPLIANCES_CONFIG = useGROUPED_NON_COMPLIANCES_CONFIG()
  const PERIODIC_SERVICE_ORDERS_BY_STATUS_CONFIG = usePERIODIC_SERVICE_ORDERS_BY_STATUS_CONFIG()
  const SERVICE_ORDERS_COUNTER_CONFIG = useSERVICE_ORDERS_COUNTER_CONFIG()
  const GROUPED_EVENTS_BY_REASON_CONFIG = useGROUPED_EVENTS_BY_REASON_CONFIG()
  const AVERAGE_EVENTS_AMOUNT_BY_PERIOD_CONFIG = useAVERAGE_EVENTS_AMOUNT_BY_PERIOD_CONFIG()
  const PERIODIC_FORM_REPLIES_CONFIG = usePERIODIC_FORM_REPLIES_CONFIG()
  const AVERAGE_FORM_REPLIES_AMOUNT_BY_PERIOD_CONFIG = useAVERAGE_FORM_REPLIES_AMOUNT_BY_PERIOD_CONFIG()
  const FORMS_COUNTER_CONFIG = useFORMS_COUNTER_CONFIG()
  const FORM_REPLIES_COUNTER_CONFIG = useFORM_REPLIES_COUNTER_CONFIG()
  const USERS_COUNTER_CONFIG = useUSERS_COUNTER_CONFIG()
  const USERS_RANKING_CONFIG = useUSERS_RANKING_CONFIG()
  const PLACES_COUNTER_CONFIG = usePLACES_COUNTER_CONFIG()
  const PLACES_RANKING_CONFIG = usePLACES_RANKING_CONFIG()
  const CHECKLISTS_RANKING_CONFIG = useCHECKLISTS_RANKING_CONFIG()
  const EMBED_CONFIG = useEMBED_CONFIG()

  return [
    COMPLIANCES_COUNTER_CONFIG,
    NON_COMPLIANCES_COUNTER_CONFIG,
    PERIODIC_NON_COMPLIANCES_CONFIG,
    GROUPED_NON_COMPLIANCES_CONFIG,
    PERIODIC_SERVICE_ORDERS_BY_STATUS_CONFIG,
    SERVICE_ORDERS_COUNTER_CONFIG,
    GROUPED_EVENTS_BY_REASON_CONFIG,
    AVERAGE_EVENTS_AMOUNT_BY_PERIOD_CONFIG,
    PERIODIC_FORM_REPLIES_CONFIG,
    AVERAGE_FORM_REPLIES_AMOUNT_BY_PERIOD_CONFIG,
    FORMS_COUNTER_CONFIG,
    FORM_REPLIES_COUNTER_CONFIG,
    USERS_COUNTER_CONFIG,
    USERS_RANKING_CONFIG,
    PLACES_COUNTER_CONFIG,
    PLACES_RANKING_CONFIG,
    CHECKLISTS_RANKING_CONFIG,
    EMBED_CONFIG
  ]
}

export const useGetWidget = type => {
  const configs = useWIDGET_CONFIGS()
  return configs.find(propEq('id', type))
}
